import { ClienteInternacional } from "../../ClienteInternacional/ClienteInternacional";
import { DescuentoRecargo } from "../DescuentoRecargo";
import { DetalleDte } from "../DetalleDte";
import { FacturaExportacion } from "../FacturaExportacion";
import { OtraMoneda } from "../OtraMoneda";
import { Bulto } from "./Bulto";

export class DteExportacionCompleto {
   dteExportacion: FacturaExportacion;
   clienteInternacional: ClienteInternacional;
   bultos: Bulto[];
   detalledtes: DetalleDte[];
   totalOtraMonedaEnt: OtraMoneda;
   descuentoRecargos: DescuentoRecargo[];
   descuentoGlobal: number;
}
